<template>
    <div>
      
        <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="Scramble Quiz Leaderboard" active>
                <hr>
                <Scrambleleaderboard>
                    
                </Scrambleleaderboard>
              </CTab>
              <CTab title="DFS Quiz Leaderboard">
                <hr>
              <DFSquizleaderboard></DFSquizleaderboard>
              </CTab>
             <CTab title="DFS Prediction Leaderboard">
                <hr>
                <Leaderboardprediction></Leaderboardprediction>
             </CTab>
            </CTabs>
        
      </CCol>
    
    </CCard>


    </div>
</template>
<script>
import Scrambleleaderboard from "./scrambleleaderboard.vue"
import DFSquizleaderboard from "./DFSquizleaderboard.vue"
import Leaderboardprediction from "./predictionleaderboard.vue"
export default {
     components: {
    Scrambleleaderboard,
    DFSquizleaderboard,
    Leaderboardprediction
  },
    data() {
    return {
      activeTab: 1,
      
   
     
    };
  },
}
</script>